module.exports = __webpack_public_path__ + "static/media/19.9daa35c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/19.png
// module id = 385
// module chunks = 0